import {Injectable} from '@angular/core';
import {GenericServicesMotoristaService} from './generic-services-motorista.service';
import {MensagensService} from 'max-ng-lib';
import {HttpClient} from '@angular/common/http';

@Injectable({providedIn: 'root'})
export class NotificacaoService extends GenericServicesMotoristaService {

	constructor(private _mensagensService: MensagensService,
				private _httpClient: HttpClient) {
		super();
	}

	getMensagensService(): MensagensService {
		return this._mensagensService;
	}

	getHttpClient(): HttpClient {
		return this._httpClient;
	}

	getUrlRecurso(): string {
		return '/notificacaoController';
	}

	listarNotificacoesPorResponsavel() {
		return this.get<any[]>('/listarNotificacoes', {exibirLoading: false});
	}

	dispensarTodas() {
		return this.post('/dispensarTodas');
	}

	dispensar(id) {
		return this.post('/dispensar', {
			dados: {
				id: id
			},
			enviarComoQueryString: true
		});
	}

	obterTipoNotificacaoPortal() {
		return this.get<any[]>('/tipoNotificacaoPortal');
	}

	listarNotificacoesPorUsuario(idUsuario, mensagemLida) {
		return this.get<any[]>('/listarPorUsuario', {
			dados: {
				idUsuario: idUsuario,
				mensagemLida: mensagemLida
			}
		});
	}

	dispensarNotificacoes(idUsuario, idsNotificacoes) {
		return this.put(`/dispensarNotificacoesUsuario?id=${idUsuario}`, {dados: idsNotificacoes });
	}

	pesquisar(filtro: any, query: string) {
		return this.post<any>(`/pesquisar?${query}`, {
			dados: filtro
		});
	}

}
